module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "discussView"
  }, [_c('div', {
    staticClass: "bumenName"
  }, [_vm._v("评价订单")]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "order_tb"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "tr-th"
  }, [_c('td', {
    attrs: {
      "colspan": "8"
    }
  }, [_c('span', {
    staticClass: "dealtime"
  }, [_vm._v("创建时间：" + _vm._s(_vm.orderData.createTime))])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    staticClass: "blue",
    class: _vm.canDownContribution(_vm.orderData) ? 'down-load' : '',
    attrs: {
      "href": _vm.orderData.realPath || 'javascript:;',
      "target": "_blank",
      "disabled": !_vm.orderData.realPath
    },
    on: {
      "~mouseenter": function($event) {
        return _vm.downContribution(_vm.orderData)
      }
    }
  }, [_vm._v(_vm._s(_vm.orderData.contributionName))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._options.pressingStatus[_vm.orderData.pressingStatus]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.orderData.dubboNum))]), _vm._v(" "), _c('td', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.orderData.appointPrice))]), _vm._v(" "), _c('td', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.orderData.realityPrice))]), _vm._v(" "), _c('td', [_c('i', {
    directives: [{
      name: "jq-tips",
      rawName: "v-jq-tips",
      value: ('已需求'),
      expression: "'已需求'"
    }],
    staticClass: "demand on"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "jq-tips",
      rawName: "v-jq-tips",
      value: (_vm.orderData.auditionIds ? '已有老师试音，查看试音详情请点击右侧‘查看试音’' : '尚无老师试音'),
      expression: "orderData.auditionIds?'已有老师试音，查看试音详情请点击右侧‘查看试音’':'尚无老师试音'"
    }],
    staticClass: "demo",
    class: {
      on: _vm.orderData.auditionIds
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "jq-tips",
      rawName: "v-jq-tips",
      value: (_vm.orderData.payId ? '已经支付订单费用' : '订单尚未支付'),
      expression: "orderData.payId?'已经支付订单费用':'订单尚未支付'"
    }],
    staticClass: "pay",
    class: {
      on: _vm.orderData.payId
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "jq-tips",
      rawName: "v-jq-tips",
      value: ((_vm.orderData.productId || _vm.orderData.voiceLength) ? '已经录制成品' : '尚未录制成品'),
      expression: "(orderData.productId || orderData.voiceLength)?'已经录制成品':'尚未录制成品'"
    }],
    staticClass: "finished",
    class: {
      on: _vm.orderData.productId || _vm.orderData.voiceLength
    }
  }), _vm._v(" "), (_vm.orderData.orderStatus == 10) ? _c('i', {
    directives: [{
      name: "jq-tips",
      rawName: "v-jq-tips",
      value: ('已取消'),
      expression: "'已取消'"
    }],
    staticClass: "canceled"
  }) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "dubbingGrade gradeWrap"
  }, [_c('div', {
    staticClass: "hd clearfix"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("声音水平")]), _vm._v(" "), _c('div', {
    staticClass: "grade"
  }, _vm._l((5), function(item) {
    return _c('i', {
      staticClass: "iconfont",
      class: [item <= (_vm.dubbingGradeHover || _vm.dubbingGradeData) ? 'icon-shoucang' : 'icon-shoucang1', {
        'on': item == _vm.dubbingGradeData
      }],
      on: {
        "click": function($event) {
          return _vm.gradeFn(1, item)
        },
        "mouseenter": function($event) {
          return _vm.gradeEnter(1, item)
        },
        "mouseleave": function($event) {
          _vm.dubbingGradeHover = 0
        }
      }
    })
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "small",
    domProps: {
      "innerHTML": _vm._s(_vm.dubbingGradeHint ? _vm.dubbingGradeHint : _vm.performance[(_vm.dubbingGradeHover || _vm.dubbingGradeData) - 1])
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bd"
  }, [_vm._v("声音成品是否满意?")])]), _vm._v(" "), _c('div', {
    staticClass: "serviceGrade gradeWrap"
  }, [_c('div', {
    staticClass: "hd clearfix"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("沟通能力")]), _vm._v(" "), _c('div', {
    staticClass: "grade"
  }, _vm._l((5), function(item) {
    return _c('i', {
      staticClass: "iconfont",
      class: [item <= (_vm.serviceGradeHover || _vm.serviceGradeData) ? 'icon-shoucang' : 'icon-shoucang1', {
        'on': item == _vm.serviceGradeData
      }],
      on: {
        "click": function($event) {
          return _vm.gradeFn(2, item)
        },
        "mouseenter": function($event) {
          return _vm.gradeEnter(2, item)
        },
        "mouseleave": function($event) {
          _vm.serviceGradeHover = 0
        }
      }
    })
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "small",
    domProps: {
      "innerHTML": _vm._s(_vm.serviceGradeHint ? _vm.serviceGradeHint : _vm.performance[(_vm.serviceGradeHover || _vm.serviceGradeData) - 1])
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bd"
  }, [_vm._v("服务过程双方沟通是否理解清晰?")])]), _vm._v(" "), _c('div', {
    staticClass: "textarea"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.textareaHint),
      expression: "textareaHint"
    }],
    staticClass: "textareaHint"
  }, [_vm._v(_vm._s(_vm.textareaHint))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.textarea),
      expression: "textarea"
    }],
    attrs: {
      "disabled": !_vm.haveComments,
      "placeholder": "评论字数限制在5-200字符"
    },
    domProps: {
      "value": (_vm.textarea)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.textarea = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wordsNumber",
    class: {
      'warn': _vm.textareaNum > 200
    }
  }, [_vm._v(_vm._s(_vm.textareaNum) + "/200字数")])]), _vm._v(" "), (_vm.haveComments) ? _c('div', {
    staticClass: "submitWrap"
  }, [_c('a', {
    staticClass: "confirm",
    on: {
      "click": function($event) {
        return _vm.submitFn()
      }
    }
  }, [_vm._v("确定")]), _c('router-link', {
    staticClass: "abandon",
    attrs: {
      "to": {
        name: 'OrderView'
      }
    }
  }, [_vm._v("放弃")])], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col', {
    staticClass: "name_col"
  }), _vm._v(" "), _c('col', {
    staticClass: "priority_col"
  }), _vm._v(" "), _c('col', {
    staticClass: "teacher_col"
  }), _vm._v(" "), _c('col', {
    staticClass: "pricing_col"
  }), _vm._v(" "), _c('col', {
    staticClass: "pay_col"
  }), _vm._v(" "), _c('col', {
    staticClass: "state_col"
  }), _vm._v(" "), _c('col', {
    staticClass: "operate_col"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "hd"
  }, [_c('td', [_vm._v("稿件名称")]), _vm._v(" "), _c('td', [_vm._v("紧急")]), _vm._v(" "), _c('td', [_vm._v("选定老师")]), _vm._v(" "), _c('td', [_vm._v("定价")]), _vm._v(" "), _c('td', [_vm._v("实际付款")]), _vm._v(" "), _c('td', [_vm._v("订单状态")]), _vm._v(" "), _c('td')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4246c61d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/DiscussView.vue
// module id = 858
// module chunks = 1